import React from 'react'
import PropTypes from 'prop-types'

// Path
import { PATH_TICKET_VIEW } from 'routes/paths'

// Components
import Link from 'ui/Link'

// Models
import TicketInfoModel from 'models/Ticket'

function ColumnAction({ row }) {
  return (
    <Link path={PATH_TICKET_VIEW} params={{ id: row.id }} underline>
      View
    </Link>
  )
}

ColumnAction.propTypes = {
  row: PropTypes.instanceOf(TicketInfoModel),
}

ColumnAction.defaultProps = {
  row: new TicketInfoModel(),
}

export default ColumnAction
